module.exports = __webpack_public_path__ + "img/right_tzmb.d366df0e.svg";